import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyAnMC5WF7erqkMfIqQnrEjXKxFsQV4Yfrs',
  authDomain: 'tbp-svp-63eac.firebaseapp.com',
  projectId: 'tbp-svp-63eac',
  storageBucket: 'tbp-svp-63eac.firebasestorage.app',
  messagingSenderId: '625915153805',
  appId: '1:625915153805:web:7d2d0a9eb1b9673a0f81c4',
  measurementId: 'G-SZBVNN23DZ'
};

// Check if we're in a snapshot environment (react-snap)
const isSnapshot = navigator.userAgent === 'ReactSnap';

// Initialize Firebase (but skip if in snapshot mode to avoid errors)
const app = !isSnapshot ? initializeApp(firebaseConfig) : undefined;

// Initialize Firebase services
export const db = app ? getFirestore(app) : null as any;
export const functions = app ? getFunctions(app) : null as any;
export const auth = app ? getAuth(app) : null as any;

export default app;
